/* eslint-disable prettier/prettier */
/* eslint-disable react/button-has-type */
/* eslint-disable react/react-in-jsx-scope */
import React, {
  useState,
  useContext,
  useEffect,
  useMemo,
  useCallback,
} from "react";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";
import { AlertStatus } from "../../../contants";
import ForceLogoutApi from "../../../services/api/ForceLogout";
import Loader from "../../../components/common/Loader/Loader";
import Pagination from "../../../components/common/new/Pagination/Pagination";

// ─── Styles (scoped inline — no external CSS needed) ──────────────────────────

const S = {
  page: {
    padding: "16px",
    fontFamily: "'Segoe UI', sans-serif",
    color: "#1a1a2e",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "16px",
    flexWrap: "wrap",
    gap: "10px",
  },
  title: {
    fontSize: "18px",
    fontWeight: "700",
    color: "#1a1a2e",
    margin: 0,
  },
  badge: (count) => ({
    display: "inline-block",
    marginLeft: "8px",
    backgroundColor: count > 0 ? "#e74c3c" : "#95a5a6",
    color: "#fff",
    borderRadius: "12px",
    padding: "2px 10px",
    fontSize: "12px",
    fontWeight: "600",
    verticalAlign: "middle",
  }),
  toolbar: {
    display: "flex",
    gap: "8px",
    marginBottom: "12px",
    flexWrap: "wrap",
    alignItems: "center",
  },
  searchInput: {
    flex: "0 1 280px",
    padding: "8px 12px",
    border: "1px solid #dde1e7",
    borderRadius: "6px",
    fontSize: "13px",
    outline: "none",
  },
  refreshBtn: {
    padding: "8px 18px",
    backgroundColor: "#3498db",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
  },
  logoutAllBtn: {
    padding: "8px 18px",
    backgroundColor: "#e74c3c",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    marginLeft: "auto",
  },
  meta: {
    fontSize: "12px",
    color: "#888",
    marginBottom: "8px",
  },
  tableWrap: {
    overflowX: "auto",
    borderRadius: "8px",
    border: "1px solid #e8eaed",
    boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: "13px",
    minWidth: "700px",
  },
  thead: {
    backgroundColor: "#f0f4f8",
  },
  th: {
    padding: "11px 14px",
    textAlign: "left",
    fontWeight: "700",
    color: "#444",
    fontSize: "12px",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    borderBottom: "2px solid #dde1e7",
    whiteSpace: "nowrap",
  },
  thCenter: {
    textAlign: "center",
  },
  tr: (idx) => ({
    backgroundColor: idx % 2 === 0 ? "#fff" : "#fafbfc",
    borderBottom: "1px solid #eef0f3",
    transition: "background 0.15s",
  }),
  td: {
    padding: "10px 14px",
    verticalAlign: "middle",
    color: "#2c3e50",
  },
  tdCenter: {
    textAlign: "center",
  },
  snCell: {
    color: "#888",
    fontWeight: "600",
    fontSize: "12px",
  },
  memberIdChip: {
    display: "inline-block",
    backgroundColor: "#ebf5fb",
    color: "#1a6ea8",
    borderRadius: "4px",
    padding: "3px 8px",
    fontWeight: "700",
    fontSize: "13px",
    fontFamily: "monospace",
  },
  sessionsBadge: {
    display: "inline-block",
    backgroundColor: "#eafaf1",
    color: "#1e8449",
    borderRadius: "12px",
    padding: "2px 8px",
    fontSize: "12px",
    fontWeight: "600",
  },
  timeText: {
    fontFamily: "monospace",
    fontSize: "12px",
    color: "#555",
  },
  ttlChip: (minutes) => ({
    display: "inline-block",
    backgroundColor: minutes < 10 ? "#fdf2f2" : "#f0f9f4",
    color: minutes < 10 ? "#c0392b" : "#1e8449",
    borderRadius: "4px",
    padding: "2px 7px",
    fontSize: "11px",
    fontWeight: "600",
  }),
  actionBtn: {
    padding: "6px 14px",
    backgroundColor: "#e74c3c",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    fontSize: "12px",
    fontWeight: "600",
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
  emptyRow: {
    padding: "32px",
    textAlign: "center",
    color: "#aaa",
    fontSize: "14px",
  },
  // ── Confirm Modal ──
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(10,10,30,0.55)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  },
  modal: {
    backgroundColor: "#fff",
    borderRadius: "10px",
    padding: "36px 32px 28px",
    maxWidth: "440px",
    width: "90%",
    textAlign: "center",
    boxShadow: "0 8px 40px rgba(0,0,0,0.18)",
  },
  modalIcon: {
    fontSize: "44px",
    marginBottom: "12px",
  },
  modalTitle: {
    fontSize: "18px",
    fontWeight: "700",
    color: "#1a1a2e",
    margin: "0 0 8px",
  },
  modalBody: {
    color: "#666",
    fontSize: "14px",
    lineHeight: "1.6",
    marginBottom: "24px",
  },
  modalHighlight: {
    color: "#e74c3c",
    fontWeight: "700",
  },
  modalActions: {
    display: "flex",
    gap: "12px",
    justifyContent: "center",
  },
  cancelBtn: {
    padding: "10px 28px",
    backgroundColor: "#f0f0f0",
    color: "#444",
    border: "1px solid #ddd",
    borderRadius: "6px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
  },
  confirmBtn: {
    padding: "10px 28px",
    backgroundColor: "#e74c3c",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
  },
};

// ─── Helpers ──────────────────────────────────────────────────────────────────

function flattenToRows(data) {
  const rows = [];
  (data || []).forEach((member) => {
    (member.sessions || []).forEach((session) => {
      rows.push({
        memberId: member.memberId,
        activeSessions: member.activeSessions,
        sessionId: session.sessionId,
        loginTime: session.loginTime,
        lastAccessedTime: session.lastAccessedTime,
        ttlSeconds: session.ttlSeconds,
        ttlMinutes:
          typeof session.ttlMinutes === "number" ? session.ttlMinutes : null,
      });
    });
  });
  return rows;
}

const norm = (v) => (v ?? "").toString().trim().toLowerCase();

// ─── Component ────────────────────────────────────────────────────────────────

const PAGE_SIZE = 10;

function ForceLogout() {
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);

  // Confirm modal state
  const [confirmModal, setConfirmModal] = useState({
    open: false,
    type: null, // "single" | "all"
    memberId: null,
  });

  const toast = useContext(ToastAlertContext);

  // ── Fetch live logged-in members ──────────────────────────────────
  const fetchActiveMembers = useCallback(async () => {
    try {
      setIsLoading(true);
      const resp = await ForceLogoutApi.getActiveLoggedInMembers();
      const data = resp?.data?.data?.content ?? resp?.data?.content ?? resp ?? [];
      setRows(flattenToRows(Array.isArray(data) ? data : []));
      setPage(0);
    } catch {
      toast.show("Failed to fetch active members", AlertStatus.ERROR);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchActiveMembers();
  }, [fetchActiveMembers]);

  // ── Filter + Paginate ─────────────────────────────────────────────
  const filtered = useMemo(() => {
    if (!norm(searchTerm)) return rows;
    return rows.filter(
      (r) =>
        norm(r.memberId).includes(norm(searchTerm)) ||
        norm(r.sessionId).includes(norm(searchTerm)),
    );
  }, [rows, searchTerm]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));

  const paged = useMemo(() => {
    const start = page * PAGE_SIZE;
    return filtered.slice(start, start + PAGE_SIZE);
  }, [filtered, page]);

  useEffect(() => {
    setPage(0);
  }, [searchTerm]);

  // ── Confirm helpers ───────────────────────────────────────────────
  const openSingleConfirm = (memberId) => {
    setConfirmModal({ open: true, type: "single", memberId });
  };

  const openAllConfirm = () => {
    setConfirmModal({ open: true, type: "all", memberId: null });
  };

  const closeConfirm = () => {
    setConfirmModal({ open: false, type: null, memberId: null });
  };

  // ── Logout Single Member ──────────────────────────────────────────
  const handleLogoutSingle = async () => {
    const { memberId } = confirmModal;
    closeConfirm();
    try {
      setIsLoading(true);
      await ForceLogoutApi.logoutSingleMember(memberId);
      toast.show(
        `Member ${memberId} logout successfully!`,
        AlertStatus.SUCCESS,
      );
      // Remove from local state immediately (no extra API call)
      setRows((prev) => prev.filter((r) => r.memberId !== memberId));
    } catch {
      toast.show(`Failed to logout member ${memberId}`, AlertStatus.ERROR);
    } finally {
      setIsLoading(false);
    }
  };

  // ── Logout All Members ────────────────────────────────────────────
  const handleLogoutAll = async () => {
    closeConfirm();
    try {
      setIsLoading(true);
      await ForceLogoutApi.forceLogoutAllMembers();
      toast.show("All members logged out!", AlertStatus.SUCCESS);
      setRows([]);
    } catch {
      toast.show("Failed to logout all members", AlertStatus.ERROR);
    } finally {
      setIsLoading(false);
    }
  };

  const onConfirmAction = () => {
    if (confirmModal.type === "single") handleLogoutSingle();
    else if (confirmModal.type === "all") handleLogoutAll();
  };

  // ── Render ────────────────────────────────────────────────────────
  if (isLoading) return <Loader />;

  const uniqueMembers = new Set(rows.map((r) => r.memberId)).size;
  const SHOW_FORCE_LOGOUT_ALL = false;

  return (
    <div style={S.page}>
      {/* HEADER */}
      <div style={S.header}>
        <h2 style={S.title}>
          Active Sessions
          <span style={S.badge(uniqueMembers)}>
            {uniqueMembers} members online
          </span>
        </h2>
      </div>

      {/* TOOLBAR */}
      <div style={S.toolbar}>
        <input
          type="text"
          placeholder="Search by Member ID..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={S.searchInput}
        />

        <button onClick={fetchActiveMembers} style={S.refreshBtn}>
          ↻ Refresh
        </button>

        {SHOW_FORCE_LOGOUT_ALL && (
          <button onClick={openAllConfirm} style={S.logoutAllBtn}>
            ⚠ Force Logout All Members
          </button>
        )}
      </div>

      {/* META */}
      <div style={S.meta}>
        Total sessions: {filtered.length} &nbsp;|&nbsp; Page: {page + 1} /{" "}
        {totalPages}
      </div>

      {/* TABLE */}
      <div style={S.tableWrap}>
        <table style={S.table}>
          <thead style={S.thead}>
            <tr>
              <th style={{ ...S.th, ...S.thCenter, width: "50px" }}>S.N.</th>
              <th style={S.th}>Member ID</th>
              <th style={S.th}>Login Time</th>
              <th style={S.th}>Last Accessed Time</th>
              <th style={{ ...S.th, ...S.thCenter }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {paged.length > 0 ? (
              paged.map((row, idx) => {
                const serial = page * PAGE_SIZE + idx + 1;
                return (
                  <tr
                    key={`${row.memberId}-${row.sessionId}`}
                    style={S.tr(idx)}
                  >
                    {/* S.N. */}
                    <td style={{ ...S.td, ...S.tdCenter, ...S.snCell }}>
                      {serial}
                    </td>

                    {/* Member ID */}
                    <td style={S.td}>
                      <span style={S.memberIdChip}>{row.memberId}</span>
                      {row.activeSessions > 1 && (
                        <span style={{ ...S.sessionsBadge, marginLeft: "6px" }}>
                          {row.activeSessions} sessions
                        </span>
                      )}
                    </td>

                    {/* Login Time */}
                    <td style={S.td}>
                      <span style={S.timeText}>{row.loginTime || "—"}</span>
                    </td>

                    {/* Last Accessed Time */}
                    <td style={S.td}>
                      <span style={S.timeText}>
                        {row.lastAccessedTime || "—"}
                      </span>
                    </td>

                    {/* Action */}
                    <td style={{ ...S.td, ...S.tdCenter }}>
                      <button
                        style={S.actionBtn}
                        onClick={() => openSingleConfirm(row.memberId)}
                      >
                        Logout
                      </button>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="6" style={S.emptyRow}>
                  {searchTerm
                    ? `"${searchTerm}" Member Not Found`
                    : "Member Not Found"}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* PAGINATION */}
      {totalPages > 1 && (
        <Pagination
          currentPage={page}
          totalPages={totalPages}
          onChange={(p) => setPage(p)}
          onPageSizeClick={(size) => console.log("New size:", size)}
        />
      )}

      {/* ── CONFIRM MODAL ──────────────────────────────────────────── */}
      {confirmModal.open && (
        <div style={S.overlay}>
          <div style={S.modal}>
            <div style={S.modalIcon}>⚠️</div>

            {confirmModal.type === "single" ? (
              <>
                <h3 style={S.modalTitle}>Confirm Member Logout?</h3>
                <p style={S.modalBody}>
                  Are you sure you want to log out member{" "}
                  <span style={S.modalHighlight}>{confirmModal.memberId}</span>?
                  <br />
                  <br />
                  This member will be logged out from{" "}
                  <strong>
                    BDS Portal, Connect Plus App, and Contribution
                  </strong>{" "}
                  — all three platforms.
                  <br />
                  They will need to log in again.
                </p>
              </>
            ) : (
              <>
                <h3 style={S.modalTitle}>Force Logout All?</h3>
                <p style={S.modalBody}>
                  Are you sure?{" "}
                  <span style={S.modalHighlight}>
                    All {uniqueMembers} members
                  </span>{" "}
                  will be logged out — including you.
                  <br />
                  <br />
                  <strong>
                    BDS Portal, Connect Plus App, and Contribution
                  </strong>{" "}
                  — all sessions across all three platforms will be terminated.
                </p>
              </>
            )}

            <div style={S.modalActions}>
              <button onClick={closeConfirm} style={S.cancelBtn}>
                Cancel
              </button>
              <button onClick={onConfirmAction} style={S.confirmBtn}>
                {confirmModal.type === "single"
                  ? `Yes, Logout ${confirmModal.memberId}`
                  : "Yes, Logout All"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ForceLogout;
